export const MAX_GAME_CARDS = 6;

export const getGames = (games = [], excludeGameIds = []) => {
  if (excludeGameIds?.length === 0) {
    return games;
  }

  if (games?.length > MAX_GAME_CARDS) {
    return games.filter((item) => !excludeGameIds.includes(item.id));
  }

  return games ?? [];
};

export const convertArrayToMatrix = (array, rows = 1) => {
  const collection = [...array];
  const matrix = [];

  for (let i = 0; i < rows; i++) {
    matrix.push(getNthElements(collection, rows));
    collection.shift();
  }

  return matrix;
};

export const getNthElements = (array, delta) => {
  const length = array.length;
  const elements = [];

  for (let i = 0; i < length; i = i + delta) {
    elements.push(array[i]);
  }

  return elements;
};

export const chunkify = (arr = [], chunkSize = 1) => {
  const array = [...arr];
  const result = [];

  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }

  return result;
};

export const convertGameDataToMatrix = (
  items = [],
  gamesInRaw = 1,
  lines = 1,
  scrollable = false
) => {
  const chunkSize = scrollable
    ? items.length <= gamesInRaw * lines
      ? gamesInRaw
      : Math.ceil(items.length / lines)
    : gamesInRaw;

  return chunkify(items, chunkSize)?.slice(0, lines);
};
